import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { ThemeToggleContext } from '../../src/components/Layout';
import { DARK_THEME } from '../../src/components/Layout/darkTheme';

const LampBox = styled.rect.attrs({
  x: 140,
  y: 0,
  width: 180,
  height: 80,
  fill: '#000',
  opacity: 0,
})`
  cursor: pointer;
`;

const HiIllustrationDark = ({ theme, ...props }) => {
  const { toggleTheme } = React.useContext(ThemeToggleContext);
  const [lampHovered, setLampHovered] = React.useState(false);

  return (
    <svg width={411} height={476} viewBox="0 0 411 476" fill="none" {...props}>
      {theme.name === DARK_THEME && (
        <path
          d="M46 410l96-375h176l93 375H46z"
          fill="#FFFA84"
          fillOpacity={0.08}
        />
      )}
      <circle
        cx={230.731}
        cy={34.1274}
        r={16.126}
        fill="#FFF743"
        fillOpacity={theme.name === DARK_THEME ? 0.9 : 0.4}
        stroke="#FFE600"
        strokeOpacity={theme.name === DARK_THEME ? 0.9 : 0.4}
        strokeWidth={3}
      />
      <path
        d="M245.357 34.615c.195 6.24-5.119 10.888-7.8 12.432 5.85-7.215 5.688-13.57 4.875-15.845.894-1.462 2.73-2.828 2.925 3.413z"
        fill="#F3F3F3"
        fillOpacity={0.56}
      />
      <path
        fill="#C4C4C4"
        d={`M253.645 34.615H255V${lampHovered ? 75 : 60}H253.645z`}
      />
      <rect
        x={252.67}
        y={lampHovered ? 75 : 60}
        width={3.41274}
        height={4.87535}
        rx={1.70637}
        fill="#A7A7A7"
      />
      <path
        d="M232 35h-90l75-35h14l0 35H318L242.188 0H231v35z"
        fill="#3F3D56"
      />
      <path
        d="M242.188 0h-6.825L272.5 35H318L242.188 0z"
        fill="#3F3D56"
        opacity={0.2}
      />
      <LampBox
        onClick={toggleTheme}
        onMouseEnter={() => setLampHovered(true)}
        onMouseLeave={() => setLampHovered(false)}
      />
      <path
        opacity={0.2}
        d="M313.713 248.613h-25.892v13.457h25.892v-13.457zM329.293 264.455h-25.891v13.457h25.891v-13.457zM313.215 280.511h-25.892v13.457h25.892v-13.457z"
        fill={theme.colors.primary.base}
      />
      <path
        d="M61.121 230.409s36.492 36.528 15.893 90.71c-9.94 26.146-2.064 60.675 8.747 89.407l-50.284.184c-17.36-32.485-18.017-73.645 4.647-108.281 15.475-23.72 28.192-51.516 20.997-72.02z"
        fill={theme.colors.tertiary.base}
      />
      <path
        d="M61.121 230.409s20.599 44.777 0 81.3c-11.852 21.016-11.28 63.433 1.81 98.853"
        stroke="#535461"
        strokeWidth={0.529167}
        strokeMiterlimit={10}
      />
      <path
        d="M.107 378.146s41.64-6.639 45.434 30.717c3.794 37.355 80.075 42.534 80.075 42.534s-.498.339-1.429.952C61.206 493.716 1.003 478.709 10.08 423.76c3.37-20.429 3.092-40.949-9.973-45.614z"
        fill={theme.colors.tertiary.light}
      />
      <path
        d="M.107 378.146s32.32 7.102 29.665 36.518c-2.653 29.416 48 64.698 95.844 36.733"
        stroke="#535461"
        strokeWidth={0.529167}
        strokeMiterlimit={10}
      />
      <path
        opacity={0.2}
        d="M107.284 173.915H81.392v13.457h25.892v-13.457zM125.706 189.366H99.815v13.457h25.891v-13.457z"
        fill={theme.colors.primary.base}
      />
      <path
        d="M217.417 234.698c32.885 0 59.543-26.684 59.543-59.601s-26.658-59.602-59.543-59.602c-32.884 0-59.542 26.685-59.542 59.602s26.658 59.601 59.542 59.601z"
        fill="#000"
      />
      <path
        d="M285.229 311.683l45.441 48.284a8.867 8.867 0 0011.422 1.276 8.878 8.878 0 002.794-3.043l50.332-90.39-14.059-4.967-41.349 59.601s-77.626-80.988-88.487-76.985c-10.86 4.004 33.906 66.224 33.906 66.224z"
        fill={theme.colors.primary.base}
      />
      <path
        d="M215.842 243.804h23.077a46.284 46.284 0 0132.747 13.577 46.39 46.39 0 0113.564 32.779v122.514H152.913V306.795a63.008 63.008 0 0118.431-44.542 62.923 62.923 0 0120.416-13.654 62.869 62.869 0 0124.082-4.795z"
        fill={theme.colors.primary.base}
      />
      <path
        d="M381.159 262.843s10.751-32.284 18.194-23.178c7.443 9.106-4.135 28.145-4.135 28.145l-14.059-4.967z"
        fill="#D19B7A"
      />
      <path
        opacity={0.05}
        d="M152.913 416.538l132.316.275v-4.139H152.913v3.864zM339.81 322.444l-21.501-21.522 17.366 29.8 4.135-8.278z"
        fill="#000"
      />
      <path
        d="M219.071 214.831c-9.134 0-16.539 7.412-16.539 16.556v16.556c0 9.143 7.405 16.556 16.539 16.556 9.135 0 16.54-7.413 16.54-16.556v-16.556c0-9.144-7.405-16.556-16.54-16.556z"
        fill="#D19B7A"
      />
      <path
        opacity={0.05}
        d="M219.071 216.487a16.531 16.531 0 00-11.695 4.849 16.561 16.561 0 00-4.844 11.706v5.625a52.873 52.873 0 0033.079 0v-5.625c0-4.39-1.743-8.602-4.844-11.706a16.532 16.532 0 00-11.696-4.849z"
        fill="#000"
      />
      <path
        d="M219.071 239.665c29.231 0 52.927-23.72 52.927-52.979 0-29.26-23.696-52.979-52.927-52.979-29.231 0-52.927 23.719-52.927 52.979 0 29.259 23.696 52.979 52.927 52.979z"
        fill="#D19B7A"
      />
      <path
        opacity={0.05}
        d="M166.144 184.282s13.232 3.413 20.675-11.64c7.443-15.054 13.232-23.265 43.83-14.369 30.598 8.895 36.753 9.98 38.224 1.569 1.005-5.748-9.875-19.71-16.867-27.975-3.41-4.033-8.976-6.438-14.925-6.438h-34.55l-20.674 9.579-15.713 13.685-3.308 18.475 3.308 17.114z"
        fill="#000"
      />
      <path
        d="M166.144 182.626s13.232 3.413 20.675-11.64c7.443-15.053 13.232-23.264 43.83-14.369s36.753 9.98 38.224 1.569c1.005-5.748-9.875-19.709-16.867-27.975-3.41-4.032-8.976-6.438-14.925-6.438h-34.55l-20.674 9.58-15.713 13.685-3.308 18.474 3.308 17.114z"
        fill="#000"
      />
      <path
        d="M171.52 193.308c2.968 0 5.375-4.818 5.375-10.761s-2.407-10.761-5.375-10.761c-2.969 0-5.376 4.818-5.376 10.761s2.407 10.761 5.376 10.761z"
        fill="#D19B7A"
      />
      <path
        d="M167.678 154.856c-1.227-6.929-2.432-14.206-.199-20.879a21.553 21.553 0 015.319-8.401 21.51 21.51 0 018.522-5.112c4.171-1.283 8.665-1.256 12.809-2.622 5.832-1.922 10.404-6.384 15.47-9.857a50.939 50.939 0 0114.626-6.909c4.684-1.355 10.197-1.877 14.014 1.159 3.212 2.555 4.328 6.936 6.983 10.068 3.09 3.645 7.888 5.225 12.078 7.518a36.852 36.852 0 0112.911 12.102 36.889 36.889 0 015.787 16.729c.145 1.777-.003 3.889-1.501 4.854a5.363 5.363 0 01-3.016.551c-21.153-.303-42.332-.607-63.398-2.55-6.548-.605-13.11-1.368-19.682-1.119a64.337 64.337 0 00-28.981 8.185"
        fill="#000"
      />
      <path
        opacity={0.05}
        d="M193.071 172.245l.372 5.456s2.031-.25 2.143 3.02c.256 7.422 1.807 16.452 4.322 17.921 3.759 2.195 25.684 7.525 31.635-6.27 5.951-13.795 9.083-13.795 13.468-2.509 4.385 11.287 12.841 11.287 20.985 10.974 8.143-.314 12.215-1.881 13.781-11.287 1.566-9.406 1.566-17.871 1.566-17.871s-12.215-1.567-17.54-1.254c-5.324.314-18.479 4.389-24.743 4.703-6.265.313-17.227-4.389-25.371-4.703-8.143-.313-20.618 1.82-20.618 1.82z"
        fill="#000"
      />
      <path
        d="M193.071 171.214l.372 5.456s2.031-.25 2.143 3.02c.256 7.422 1.807 16.452 4.322 17.921 3.759 2.195 25.684 7.524 31.635-6.271 5.951-13.794 9.083-13.794 13.468-2.508 4.385 11.287 12.841 11.287 20.985 10.974 8.143-.314 12.215-1.882 13.781-11.287 1.566-9.406 1.566-17.871 1.566-17.871s-12.215-1.568-17.54-1.254c-5.324.313-18.479 4.389-24.743 4.703-6.265.313-17.227-4.39-25.371-4.703-8.143-.314-20.618 1.82-20.618 1.82z"
        fill="#000"
      />
      <path
        d="M214.261 172.528s16.889 1.38 16.717 6.9c-.172 5.521-3.619 19.667-16.2 18.114-12.581-1.553-13.788-2.07-15.339-12.938-1.551-10.869-.517-12.421 14.822-12.076zM262.591 172.268s-16.887 1.381-16.715 6.901c.172 5.52 3.886 19.132 16.198 18.114 12.632-1.045 13.786-2.07 15.337-12.939 1.551-10.868.517-12.421-14.82-12.076z"
        fill="#F2F2F2"
      />
      <path
        d="M321.357 408.444v2.564a5.97 5.97 0 01-.746 2.902 5.495 5.495 0 01-1.946 2.031 5.082 5.082 0 01-2.634.741H138.952a5.082 5.082 0 01-2.634-.741 5.503 5.503 0 01-1.946-2.031 5.949 5.949 0 01-.745-2.902v-2.564c0-.745.137-1.483.405-2.172a5.716 5.716 0 011.154-1.841 5.32 5.32 0 011.728-1.23 5.045 5.045 0 012.038-.431h10.208v-1.196a.244.244 0 01.064-.167.23.23 0 01.073-.051.206.206 0 01.085-.018h5.325a.215.215 0 01.157.069.227.227 0 01.048.077.229.229 0 01.017.09v1.196h3.327v-1.196a.248.248 0 01.065-.167.225.225 0 01.072-.051.21.21 0 01.085-.018h5.326a.215.215 0 01.157.069.248.248 0 01.065.167v1.196h3.331v-1.196a.248.248 0 01.065-.167.225.225 0 01.072-.051.21.21 0 01.085-.018h5.326a.21.21 0 01.085.018.225.225 0 01.12.128.248.248 0 01.017.09v1.196h3.327v-1.196a.248.248 0 01.065-.167.225.225 0 01.072-.051.21.21 0 01.085-.018h5.326a.21.21 0 01.085.018.225.225 0 01.12.128.248.248 0 01.017.09v1.196h3.327v-1.196c0-.031.005-.062.017-.09a.227.227 0 01.12-.128.21.21 0 01.085-.018h5.325c.03 0 .059.006.085.018a.23.23 0 01.138.218v1.196h3.331v-1.196a.247.247 0 01.064-.167.23.23 0 01.073-.051.206.206 0 01.085-.018h5.325a.215.215 0 01.157.069.247.247 0 01.049.077.247.247 0 01.016.09v1.196h3.327v-1.196a.248.248 0 01.065-.167.225.225 0 01.072-.051.21.21 0 01.085-.018h41.717a.215.215 0 01.157.069.247.247 0 01.049.077.247.247 0 01.016.09v1.196h3.331v-1.196a.248.248 0 01.065-.167.225.225 0 01.072-.051.21.21 0 01.085-.018h5.326c.059 0 .115.025.157.07a.245.245 0 01.065.166v1.196h3.327v-1.196a.248.248 0 01.065-.167.225.225 0 01.072-.051.21.21 0 01.085-.018h5.326a.21.21 0 01.085.018.225.225 0 01.12.128.248.248 0 01.017.09v1.196h3.327v-1.196a.248.248 0 01.065-.167.225.225 0 01.072-.051.21.21 0 01.085-.018h5.326a.21.21 0 01.085.018.225.225 0 01.12.128.248.248 0 01.017.09v1.196h3.331v-1.196a.248.248 0 01.065-.167.215.215 0 01.157-.069h5.326a.213.213 0 01.154.07.244.244 0 01.064.166v1.196h3.331v-1.196c0-.031.005-.062.016-.09a.247.247 0 01.049-.077.215.215 0 01.157-.069h5.325c.03 0 .058.006.085.018a.23.23 0 01.137.218v1.196h3.328v-1.196a.244.244 0 01.064-.167.23.23 0 01.073-.051.203.203 0 01.085-.018h5.325a.215.215 0 01.157.069.227.227 0 01.048.077.229.229 0 01.017.09v1.196h15.533c.7 0 1.392.146 2.038.431a5.314 5.314 0 011.728 1.23 5.718 5.718 0 011.155 1.841c.267.689.405 1.427.405 2.172z"
        fill="#3F3D56"
      />
      <path
        d="M411 410.033H46.03v.997H411v-.997zM313.215 300.448h-70.248v-1.45h-31.853v1.45h-70.538a4.744 4.744 0 00-3.36 1.393 4.757 4.757 0 00-1.392 3.363v96.286a4.758 4.758 0 004.752 4.757h172.639a4.758 4.758 0 004.752-4.757v-96.286a4.754 4.754 0 00-4.752-4.756z"
        fill="#3F3D56"
      />
      <path
        d="M225.991 366.848c6.874 0 12.447-5.579 12.447-12.46 0-6.882-5.573-12.46-12.447-12.46-6.875 0-12.448 5.578-12.448 12.46 0 6.881 5.573 12.46 12.448 12.46z"
        fill="#D0CDE1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M220.361 349.904s.071.321.358.039c.287-.281.944-1.868 1.733-1.667.789.202.501 1.279.494 2.139-.005.807-.248 2.956 1.926 3.942 2.175.987 3.392-1.422 3.392-1.422s.232-.577-.449-.326c-.682.251-2.073.454-2.622-.243-.548-.698-.597-1.767-.608-2.503-.011-.737.483-2.966-.458-3.41-1.365-.644-4.159.182-3.766 3.451zm3.537 7.409s.272-.219.225.137c-.046.356-.378 2.119-.416 2.463-.038.345.206.236.274.217.068-.02 1.312-.729 2.233-1.995.913-1.254 2.178-2.838 2.575-5.488.284-1.9.224-5.691.21-6.211-.004-.122.057-.139.147-.148a6.43 6.43 0 011.436.03c.182.023.214.049.223.201.025.411.143 2.81-.048 5.01-.568 6.536-4.181 9.106-6.495 10.295-.977.502-1.74.215-1.868-.426-.177-.883-.292-1.997 1.504-4.085z"
        fill="#3F3D56"
      />
      <path
        opacity={0.7}
        d="M113.082 379.695v-7.708H74.577v35.652c0 1.993.791 3.905 2.2 5.314a7.502 7.502 0 005.309 2.201h23.487a7.504 7.504 0 005.31-2.201 7.518 7.518 0 002.199-5.314v-7.902c2.655 0 5.201-1.055 7.079-2.935a10.027 10.027 0 000-14.171 10.005 10.005 0 00-7.079-2.936zm0 16.188V383.55c1.634 0 3.201.649 4.356 1.806a6.17 6.17 0 01-4.356 10.527z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M111.843 381.899a9.141 9.141 0 00-8.445 5.648 9.156 9.156 0 001.981 9.971 9.137 9.137 0 0015.604-6.469 9.155 9.155 0 00-2.677-6.47 9.135 9.135 0 00-6.463-2.68zm0 14.78a5.633 5.633 0 01-1.098-11.153 5.623 5.623 0 016.723 5.523 5.646 5.646 0 01-1.648 3.981 5.618 5.618 0 01-3.977 1.649z"
        fill={theme.colors.primary.base}
      />
      <path
        opacity={0.1}
        d="M111.843 381.899a9.141 9.141 0 00-8.445 5.648 9.156 9.156 0 001.981 9.971 9.137 9.137 0 0015.604-6.469 9.155 9.155 0 00-2.677-6.47 9.135 9.135 0 00-6.463-2.68zm0 14.78a5.633 5.633 0 01-1.098-11.153 5.623 5.623 0 016.723 5.523 5.646 5.646 0 01-1.648 3.981 5.618 5.618 0 01-3.977 1.649z"
        fill="#000"
      />
      <path
        d="M76.687 374.861h35.156v32.515a6.893 6.893 0 01-2.019 4.878 6.871 6.871 0 01-4.873 2.02H83.578a6.88 6.88 0 01-4.873-2.02 6.905 6.905 0 01-2.018-4.878v-32.515z"
        fill={theme.colors.primary.base}
      />
      <path
        opacity={0.1}
        d="M105.515 374.861v32.551a6.857 6.857 0 01-2.008 4.853 6.86 6.86 0 01-4.848 2.009h3.516a6.851 6.851 0 006.334-4.236 6.875 6.875 0 00.521-2.626v-32.551h-3.515z"
        fill="#000"
      />
      <path
        d="M83.624 348.625a2.047 2.047 0 00-1.552.789c-.461.837.374 1.78 1.137 2.355 1.409 1.062 2.894 2.106 3.852 3.589.957 1.482 1.258 3.552.211 4.973-1.367 1.855-4.628 2.254-4.944 4.538-.202 1.466 1.064 2.717 2.347 3.453 3.167 1.815 7.25 2.3 9.543 5.141.949-1.953 3.071-3.082 5.187-3.564 2.115-.482 4.313-.446 6.458-.773a2.225 2.225 0 001.782-.947c.6-1.218-1.109-2.679-.519-3.901.449-.931 1.768-.859 2.731-1.232 1.568-.606 2.214-2.626 1.769-4.249-.445-1.623-1.702-2.891-3.024-3.931-3.563-2.802-7.846-4.45-12.18-5.635-2.014-.552-4.38-1.416-6.473-1.5-2.02-.081-4.325.551-6.325.894z"
        fill="#EEE"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1={98.8351}
          y1={415.154}
          x2={98.8351}
          y2={371.987}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.53514} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default withTheme(HiIllustrationDark);
